// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__37fHn","legacyBtn":"MutateMid_legacyBtn__6E8bY"};